import { useState, useEffect } from "react"

interface UseLogPollingProps {
  enabled: boolean
  refetchLogs: () => void
  pollingInterval?: number
}

export const useLogPolling = ({
  enabled,
  refetchLogs,
  pollingInterval = 3000
}: UseLogPollingProps) => {
  const [isPolling, setIsPolling] = useState(false)

  useEffect(() => {
    if (isPolling && enabled) {
      const interval = setInterval(() => {
        refetchLogs()
      }, pollingInterval)

      return () => clearInterval(interval)
    }
  }, [isPolling, enabled, refetchLogs, pollingInterval])

  const startPolling = () => {
    setIsPolling(true)
    refetchLogs()
  }

  const stopPolling = () => {
    setIsPolling(false)
  }

  return {
    isPolling,
    startPolling,
    stopPolling
  }
}
